<template>
  <div>
    <div id="body" class="login language-en">
      <div id="wrapper" class="wrapper-login">
        <form
          id="headerForm"
          name="headerForm"
          method="post"
          class="headerform"
          enctype="application/x-www-form-urlencoded"
          data-partialsubmit="true"
        >
          <link
            href="https://booking.vacancyrewards.com/client-styles/vacancyrewards/vacancyrewards.css?version=1710522167490"
            rel="stylesheet"
            type="text/css"
          />
          <!--Header-->
          <!-- <HeaderLogin :isDefault="isDefault" :club="club" /> -->
          <!--Fin header-->
        </form>
        <div
          id="login-form"
          name="login-form"
          class="login-form-modal o-section--huge bg-clr--lighter-gray"
        >
          <div
            id="login-form:j_id_e"
            class="ui-blockui-content ui-widget ui-widget-content ui-corner-all ui-helper-hidden ui-shadow"
          ></div>
          <div class="o-layout o-layout--center">
            <div class="o-layout__item" style="max-width: 750px">
              <div
                id="signup"
                name="signup"
                method="post"
                class="bg-clr--white o-block o-box p-40@sm u-box-shadow"
                enctype="application/x-www-form-urlencoded"
              >
                <div class="o-block__item u-font-size--huge">
                  {{ $func.parseIso("registerFree") }}
                </div>
                <div id="signup:signupform" class="o-block__item">
                  <div
                    class="o-block o-block--small o-layout o-layout--gutter-small u-font-size--small o-layout--stretch"
                  >
                    <div class="o-block__item o-layout__item u-1/2@md">
                      <label
                        id="signup:j_id_3f"
                        class="ui-outputlabel ui-widget u-font-size--small clr--darker-gray ui-required"
                        for="signup:email"
                        >{{ $func.parseIso("email")
                        }}<span class="ui-outputlabel-rfi">*</span></label
                      >
                      <div class="c-icon-escort">
                        <input
                          id="signup:email"
                          name="signup:email"
                          v-model="newUser.email"
                          class="c-icon-escort__main c-text-input true email"
                          placeholder="..."
                          type="email"
                          maxlength="255"
                        />
                        <i
                          class="c-icon-escort__icon fa-regular fa-envelope"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div
                      class="c-register__item o-block__item o-layout__item u-1/2@md"
                    >
                      <label
                        id="signup:j_id_3m"
                        class="ui-outputlabel ui-widget u-font-size--small clr--darker-gray ui-required"
                        for="signup:password"
                        >{{ $func.parseIso("password")
                        }}<span class="ui-outputlabel-rfi">*</span></label
                      >
                      <div class="c-icon-escort">
                        <span
                          class="ui-password ui-password-masked ui-inputwrapper ui-input-icon-right"
                          ><input
                            id="signup:password"
                            name="signup:password"
                            class="ui-inputfield ui-widget ui-state-default ui-corner-all c-icon-escort__main c-text-input password"
                            aria-required="true"
                            autocomplete="new-password"
                            placeholder="..."
                            v-model="newUser.password"
                            :type="isShowPass ? 'text' : 'password'"
                            @input="validaPass"
                            @focus="showValidPass = true"
                            @blur="showValidPass = false"
                            maxlength="255" />
                          <div
                            id="signup:password_panel"
                            :class="`ui-password-panel ui-widget ui-state-highlight ui-corner-all ui-password-panel-inline ${
                              !showValidPass ? 'ui-helper-hidden' : ''
                            }`"
                          >
                            <!-- ui-helper-hidden -->
                            <div
                              class="ui-password-meter"
                              :style="`background-position: 0px ${
                                validaPass() === 0 || validaPass() === -1
                                  ? '0'
                                  : validaPass() === 1
                                  ? '-10'
                                  : validaPass() === 2
                                  ? '-20'
                                  : '-30'
                              }px`"
                            >
                              &nbsp;
                            </div>
                            <div class="ui-password-info">
                              {{
                                validaPass() === 0
                                  ? $func.parseIso("changePassword__msg1")
                                  : validaPass() === -1
                                  ? $func.parseIso("changePassword__msg3")
                                  : validaPass() === 1
                                  ? $func.parseIso("changePassword__msg8")
                                  : validaPass() === 2
                                  ? $func.parseIso("changePassword__msg9")
                                  : $func.parseIso("changePassword__msg10")
                              }}
                            </div>
                          </div>
                          <i
                            id="signup:password_mask"
                            :class="
                              !isShowPass ? 'pi pi-eye' : 'pi pi-eye-slash'
                            "
                            style="cursor: pointer"
                            @click="showPass"
                          ></i
                        ></span>
                      </div>
                      <div
                        class="pb-10 o-group--tiny u-font-size--small"
                        style="margin-top: 10px"
                      >
                        <i class="fa-solid fa-circle-info clr--warning"></i>
                        <span>{{
                          $func.parseIso("changePassword__msg2")
                        }}</span>
                        <!-- <span
                          >La contraseña debe contener: al menos 8 caracteres, 1
                          mayúscula (a-Z), 1 minúscula (a-z), 1 dígito (0-9), 1
                          carácter especial y no debe contener espacios en
                          blanco.</span
                        > -->
                      </div>
                    </div>
                    <div
                      class="c-register__item o-block__item o-layout__item u-1/2@md"
                    >
                      <label
                        id="signup:j_id_3x"
                        class="ui-outputlabel ui-widget u-font-size--small clr--darker-gray ui-required"
                        for="signup:name"
                      >
                        {{ $func.parseIso("name")
                        }}<span class="ui-outputlabel-rfi">*</span></label
                      >
                      <div class="c-icon-escort">
                        <input
                          id="signup:name"
                          name="signup:name"
                          type="text"
                          v-model="newUser.name"
                          class="c-icon-escort__main c-text-input name"
                          placeholder="..."
                          maxlength="100"
                        />
                        <i
                          class="c-icon-escort__icon fa-regular fa-user"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div
                      class="c-register__item o-block__item o-layout__item u-1/2@md"
                    >
                      <label
                        id="signup:j_id_42"
                        class="ui-outputlabel ui-widget u-font-size--small clr--darker-gray ui-required"
                        for="signup:surname"
                      >
                        {{ $func.parseIso("lastname")
                        }}<span class="ui-outputlabel-rfi">*</span></label
                      >
                      <div class="c-icon-escort">
                        <input
                          id="signup:surname"
                          name="signup:surname"
                          type="text"
                          v-model="newUser.lastname"
                          class="c-icon-escort__main c-text-input surname"
                          placeholder="..."
                          maxlength="100"
                        />
                        <i
                          class="c-icon-escort__icon fa-regular fa-user"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="o-block o-layout o-layout--gutter-small o-block__item"
                >
                  <div
                    class="c-register__item o-block__item o-layout__item u-1/2@md"
                  >
                    <label
                      id="signup:j_id_4h"
                      class="ui-outputlabel ui-widget u-font-size--small clr--darker-gray"
                      for="signup:telephone"
                      >{{ $func.parseIso("cellphone") }} <span class="ui-outputlabel-rfi">*</span></label
                    >
                    <div class="c-icon-escort">
                      <div class="currency-container">
                        <select
                          class="currency-select"
                          v-model="newUser.phone"
                        >
                          <option :value="null">+??</option>
                          <option
                            :value="pais.Lada"
                            v-for="pais in Cat.CatPaises"
                          >
                            {{ pais.Id }} +{{ pais.Lada }}
                          </option>
                        </select>
                        <input
                          type="text"
                          class="currency-input"
                          v-mask="'(###) ###-##-####'"
                          placeholder="(___) ___-__-___"
                          v-model="newUser.ladaphone"
                          maxlength="20"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="o-block__item o-layout__item o-block o-block--small u-1/2@md"
                  >
                    <div
                      class="o-block__item u-font-size--small clr--darker-gray"
                    >
                      <input
                        id="signup:j_id_b2:gdprconsent"
                        type="checkbox"
                        name="signup:j_id_b2:gdprconsent"
                        class="gdprconsent must-check"
                        data-message="Debes autorizar el tratamiento de los datos personales"
                        v-model="acceptTerms"
                        style="cursor: pointer"
                      /><label
                        class="clr--darker-gray u-display--inline u-font-weight--400 ml-10"
                        for="signup:j_id_b2:gdprconsent"
                        >&nbsp;{{
                          $func.parseIso("termsAndConditions__msg3")
                        }}</label
                      >
                    </div>
                    <div class="o-block__item">
                      <button
                        :class="`ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only c-button bg-clr--brand u-1/1 register-button ${
                          (loadingRegister && 'button--loading') || ''
                        }`"
                        aria-label=""
                        tabindex="8"
                        @click="validRegister"
                        :disabled="
                          validaPass() === 3 && acceptTerms ? false : true
                        "
                        :style="`${
                          validaPass() === 3 && acceptTerms
                            ? ``
                            : `background-color: grey`
                        }; cursor: ${
                          validaPass() === 3 && acceptTerms
                            ? `pointer`
                            : `default`
                        };`"
                      >
                        <span class="ui-button-text ui-c"
                          >{{
                            loadingRegister ? "" : $func.parseIso("createUser")
                          }}
                        </span>
                      </button>
                    </div>
                    <div class="o-block__item u-font-size--tiny">
                      {{ $func.parseIso("termsAndConditions__msg4") }}
                      <a
                        id="signup:j_id_c8"
                        @click="$bus.emit('open-terms-withoutbtn')"
                        class="ui-commandlink ui-widget clr--brand-dark"
                        style="cursor: pointer"
                      >
                        {{ $func.parseIso("termsAndConditions") }} </a
                      >{{ $func.parseIso("and") }}
                      <a
                        style="cursor: pointer"
                        @click="$bus.emit('cookies')"
                        class="clr--brand-dark"
                        data-toggle="modal"
                        data-target=".privacyPolicy"
                        >{{ $func.parseIso("privacyPolicy") }}</a
                      >
                    </div>
                  </div>
                </div>
                <!-- <input
                  type="hidden"
                  name="g-recaptcha-response"
                  id="g-recaptcha-response"
                /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="j_id_c_3u:cookiesPolicy"
        class="c-modal cookiesPolicy"
        data-size="medium"
        role="dialog"
        data-closeable="false"
        tabindex="-1"
        aria-modal="true"
        data-active="false"
      >
        <div
          class="c-modal__backmask"
          onclick="$('.cookiesPolicy').modal('hide')"
        ></div>
        <div class="c-modal__wrapper">
          <div class="c-modal__container">
            <div class="c-modal__close" style="">
              <button
                type="button"
                class="c-modal__close-btn"
                data-dismiss="modal"
              >
                <span
                  class="o-box--small--horizontal o-box--tiny--vertical u-font-weight--500 u-font-size--small u-border-radius--sm u-line-height--1 u-pointer-events--none"
                >
                  Close
                  <i
                    class="fa-solid fa-caret-right u-font-size--default"
                  ></i></span
                ><i class="u-display--block fa-regular fa-close"></i>
              </button>
            </div>
            <div class="c-modal__body">
              <div
                class="c-modal__header u-font-weight--600 u-line-height--1 u-hide-empty"
              >
                Cookies policy
              </div>
              <form
                id="j_id_c_3u:cookies-consent-form"
                name="j_id_c_3u:cookies-consent-form"
                method="post"
                action="/login.xhtml"
                class="c-modal-cookies-consent"
                enctype="application/x-www-form-urlencoded"
              >
                <div id="box-cookies-main" class="box-cookies-consent">
                  <div class="o-block">
                    <div class="o-block__item">
                      We use first-party and third-party cookies (Google and
                      Facebook) to analyze the usage of our website, show you
                      tailored ads according your browsing habits and improve
                      browsing performance. You can read more about our<a
                        id="j_id_c_3u:cookies-consent-form:goPolicies"
                        href="#"
                        class="ui-commandlink ui-widget clr--brand u-font-weight--bold dev-go-cookies-details"
                        aria-label=""
                      >
                        Cookies policy
                      </a>
                      <a
                        id="j_id_c_3u:cookies-consent-form:goSettings"
                        href="#"
                        class="ui-commandlink ui-widget clr--brand u-font-weight--bold dev-go-cookies-settings"
                        aria-label=""
                      >
                        here
                      </a>
                    </div>
                    <div
                      class="o-block o-block--small o-layout o-layout--gutter-small o-block--item u-text-align--center u-text-align--right@sm"
                    >
                      <div
                        class="o-block__item o-layout__item u-display--inline"
                      >
                        <input
                          id="j_id_c_3u:cookies-consent-form:rejectAllMain"
                          name="j_id_c_3u:cookies-consent-form:rejectAllMain"
                          type="button"
                          value="Reject all"
                          onclick="rejectAllCookies()"
                          class="c-button bg-clr--brand--alpha-soft dev-reject-all"
                        />
                      </div>
                      <div
                        class="o-block__item o-layout__item u-display--inline u-text-align--right"
                      >
                        <input
                          id="j_id_c_3u:cookies-consent-form:acceptAllMain"
                          name="j_id_c_3u:cookies-consent-form:acceptAllMain"
                          type="button"
                          value="Accept all"
                          onclick="acceptAllCookies()"
                          class="c-button bg-clr--brand dev-accept-all mb-5 mb-0@sm"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <input
                  type="hidden"
                  name="j_id_c_3u:cookies-consent-form_SUBMIT"
                  value="1"
                /><input
                  type="hidden"
                  name="javax.faces.ViewState"
                  id="j_id__v_0:javax.faces.ViewState:5"
                  value="ZjAxYTZkNWIxMDRjMjMyYzAwMDAwMDAy"
                  autocomplete="off"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Footer :isDefault="isDefault" :club="club" /> -->
    <Alert
      :show="alertLogin.show"
      :title="alertLogin.title"
      :closeAlert="alertLogin.close || closealertLogin"
    />
  </div>
</template>

<script>
import Footer from "../components/Footer.vue";
import HeaderLogin from "../components/HeaderLogin.vue";
import Alert from "../components/Alert.vue";
import axios from "axios";
const { VUE_APP_TC_URL } = process.env;
import { getClubObject, setTokenTCAndExpireToken } from "../utils/sesions";
import { newUser } from "@/utils/i18n_data";
const CLUBS_V2 = [
  "96213bc2-b460-414e-980a-d0bd99d0869c",
  "f908ec94-2a57-4478-a330-9104af639e42",
  "22c92470-937f-48dc-87d3-9baa06447628",
  "b1ccd89f-f90f-470f-9ffb-acbe5f082df8",
];
const IMAGES_LOGIN = [
  "https://booking.vacancyrewards.com/javax.faces.resource/index-background/background-0.jpg",
  "https://booking.vacancyrewards.com/javax.faces.resource/index-background/background-2.jpg",
  "https://booking.vacancyrewards.com/javax.faces.resource/index-background/background-5.jpg",
  "https://booking.vacancyrewards.com/javax.faces.resource/index-background/background-1.jpg",
];

const PasswordValidator = require("password-validator");
const passhigh = new PasswordValidator();
const passmedium = new PasswordValidator();
const passlow = new PasswordValidator();
passhigh
  .is()
  .min(8)
  .is()
  .max(255)
  .has()
  .uppercase()
  .has()
  .lowercase()
  .has()
  .digits(1)
  .has()
  .not()
  .spaces()
  .has()
  .symbols(1);

passmedium
  .is()
  .min(4)
  .is()
  .max(255)
  .has()
  .uppercase()
  .has()
  .lowercase()
  .has()
  .digits(1)
  .has()
  .not()
  .spaces();

passlow.is().min(1).is().max(255).has().lowercase().has().not().spaces();

export default {
  data() {
    return {
      mode: "login",
      email: null,
      password: null,
      iso: "en",
      show: false,
      club: null,
      isDefault: true,
      isShowPass: false,
      UrlTC: null,
      MicrositeTC: null,
      ClubId: null,
      CLUBS_V2,
      IMAGES_LOGIN,
      img: "https://booking.vacancyrewards.com/javax.faces.resource/index-background/background-0.jpg",
      btnColor: null,
      loadingLogin: false,
      loadingRegister: false,
      errorLogin: null,
      msgErrorLogin: "",
      alertLogin: {
        show: false,
        title: `We’ve improved your login experience! 
        Use your registered email to access your account (each owner and co-owner now has their own access using their registered email).`,
        description: "",
        close: null,
      },
      newUser: {
        name: null,
        lastname: null,
        email: null,
        password: null,
        phone: null,
        ladaphone: null,
      },
      showValidPass: false,
      stepValidPass: 0,
      acceptTerms: false,
      Cat: {
        CatPaises: [],
        CatEstadosPais: [],
        CatIdiomas: [],
      },
    };
  },
  components: {
    Footer,
    HeaderLogin,
    Alert,
  },
  async created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
      this.$forceUpdate();
    });
    // await this.checkClub();
    this.img = this.getImgs();

    const __club = getClubObject();
    if (__club?.ColorPrimarioHex) this.btnColor = __club?.ColorPrimarioHex;

    //Check Alert
    const {
      query: { alert },
    } = this.$route;
    if (alert && alert === "confirmPayment") {
      this.alertLogin.title = this.$func.parseIso("registerUser__msg2");
      this.alertLogin.show = true;
    }

    await this.getCatalogues();
  },
  async updated() {
    // this.show = true;
    // this.$forceUpdate();
    await this.checkClub();
  },
  methods: {
    closealertLogin() {
      this.alertLogin.show = false;
    },
    getImgs() {
      const random = (mn, mx) => {
        return Math.random() * (mx - mn) + mn;
      };
      return IMAGES_LOGIN[Math.floor(random(1, 4)) - 1];
    },
    changeIso() {
      if (this.iso === "es") {
        localStorage.setItem("iso", "en");
        this.iso = "en";
      } else {
        localStorage.setItem("iso", "es");
        this.iso = "es";
      }
    },
    async login(email, password) {
      try {
        // this.loadingLogin = true;
        // this.errorLogin = null;

        const { data } = await this.$axios.post("/members-public/login", {
          email,
          password,
          clubId: this.ClubId || "all",
        });

        setTokenTCAndExpireToken(data?.token, data?.exp, data?.sesion);
        const __MicrositeTC__ = data?.MicrositeTC || this.MicrositeTC;
        const __UrlTC__ = data?.UrlTC || this.UrlTC;
        // const checkTerms =
        //   data?.AcceptTermsWeeks && data?.AcceptTermsWeeks === true
        //     ? true
        //     : false;

        const URL_REDIRECT_DASHBOARD = `https://${__UrlTC__}?submit=true&keepurl=true&token=${data?.token}&microsite=${__MicrositeTC__}`;
        window.location.href = URL_REDIRECT_DASHBOARD;
        // this.loadingLogin = false;
      } catch (error) {
        // this.loadingLogin = false;
        // const codeError = error?.response?.data?.code || 405;
        // const msgErrorLogin = error?.response?.data?.message || "";
        // this.errorLogin = codeError;
        // this.msgErrorLogin = msgErrorLogin;
        console.log(error);
        // alert(error?.response?.data?.message);
      }
    },
    checkClub() {
      return new Promise((resolve, reject) => {
        // try {
        //   const { data } = await this.$axios.get(`/auth/club`);
        //   this.club = data.club;
        //   this.isDefault = data.default;
        // } catch (error) {
        //   console.log(error);
        //   // alert(error?.response?.data?.message);
        // }
        console.log("2. checkClub");
        const { UrlTC, MicrositeTC, Id } = getClubObject();
        // console.log("UrlTC", UrlTC);
        // console.log("MicrositeTC", MicrositeTC);
        // console.log("Id", Id);
        // console.log("getClubObject()", getClubObject());
        this.UrlTC = UrlTC;
        this.MicrositeTC = MicrositeTC;
        this.ClubId = Id;
        return resolve();
      });
    },
    showPass() {
      this.isShowPass = !this.isShowPass;
    },
    goToRecoverPassword() {
      this.$router.push("/recover-password");
    },
    changeToLogin() {
      this.mode = "login";
    },
    changeToRegister() {
      this.mode = "register";
    },
    goToGoogleAuthRegister() {
      // const uriRedirect =
      //   process.env.VUE_APP_API_URL +
      //   process.env.VUE_APP_URL_GOOGLE_REDIRECT_REGISTER;
      const uriRedirect = `https://vr.vacancyrewards.com/api/members-public/register/google/callback`;
      // const uriRedirect = `http://localhost:3010/api/members-public/register/google/callback`;
      window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${uriRedirect}&response_type=code&client_id=758621452580-p1em4evmcujd5ufl5b64b7s8ohahnd9h.apps.googleusercontent.com&scope=profile email`;
    },
    goToGoogleAuthLogin() {
      // const uriRedirect =
      //   process.env.VUE_APP_API_URL +
      //   process.env.VUE_APP_URL_GOOGLE_REDIRECT_LOGIN;
      const uriRedirect = `https://vr.vacancyrewards.com/api/members-public/login/google/callback`;
      // const uriRedirect = `http://localhost:3010/api/members-public/login/google/callback`;
      window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${uriRedirect}&response_type=code&client_id=758621452580-p1em4evmcujd5ufl5b64b7s8ohahnd9h.apps.googleusercontent.com&scope=profile email`;
    },
    async registerCaptcha() {
      return new Promise((resolve, reject) => {
        try {
          grecaptcha.ready(function () {
            grecaptcha
              .execute("6LfE54IrAAAAAIhI6THMMT6FRpzyrn-nLSqBDp8z", {
                action: "submit",
              })
              .then(function (token) {
                return resolve(token);
              })
              .catch(function (error) {
                return reject();
                console.log("error", error);
              });
          });
        } catch (error) {
          console.log(error);
          return reject();
        }
      });
    },
    async registerExec(token) {
      try {
        this.loadingRegister = true;
        this.errorLogin = null;

        const { data } = await this.$axios.post("members-public/register", {
          ...this.newUser,
          token,
          autologin: true,
          clubId: this.ClubId || null,
          typeSub: 2,
          captcha: true,
        });

        if (data?.redirect) window.location.href = data?.urlPay;
        else this.login(this.newUser.email, this.newUser.password);

        this.loadingRegister = false;

        // this.newUser.name = "";
        // this.newUser.lastname = "";
        // this.newUser.email = "";
        // this.newUser.password = "";

        // this.alertLogin.title = this.$func.parseIso("registerUser__msg1");
        // this.alertLogin.close = this.closeAlertRegister;
        // this.alertLogin.show = true;
      } catch (error) {
        this.loadingRegister = false;
        const codeError = error?.response?.data?.code || 405;
        const msgErrorLogin = error?.response?.data?.message || "";
        this.errorLogin = codeError;
        this.msgErrorLogin = msgErrorLogin;

        this.alertLogin.title = msgErrorLogin;
        this.alertLogin.close = this.closeAlertRegister;
        this.alertLogin.show = true;
        console.log(error);
        // alert(error?.response?.data?.message);
      }
    },
    closeAlertRegister() {
      this.alertLogin.show = false;
      // this.mode = "login";
    },
    validaPass() {
      if (this.newUser.password === "" || !this.newUser.password) return 0;

      if (passhigh.validate(this.newUser.password)) {
        return 3;
      } else if (passmedium.validate(this.newUser.password)) {
        return 2;
      } else if (passlow.validate(this.newUser.password)) {
        return 1;
      } else {
        return -1;
      }
    },
    async validRegister() {
      try {
        const token = await this.registerCaptcha();
        // console.log('token', token)
        await this.registerExec(token);
      } catch (error) {
        console.log(error);
      }
    },
    async getCatalogues() {
      try {
        const list = ["CatPaises", "CatEstadosPais", "CatIdiomas"];

        for (let l of list) {
          const { data } = await this.$axios.get(`/catalogue/${l}`);
          this.Cat[l] = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.button--loading::after {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border: 2px solid transparent;
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: button-loading-spinner 1s ease infinite;
}
@keyframes button-loading-spinner {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}
</style>

<style scoped>
:root {
  --s-color-brand-primary: #0472aa;
  --s-color-brand-primary-hsl-hue: 200;
  --s-color-brand-primary-hsl-saturation: 95%;
  --s-color-brand-primary-hsl-light: 34%;
  --s-color-brand-primary-red: 4;
  --s-color-brand-primary-green: 114;
  --s-color-brand-primary-blue: 170;

  --s-color-brand-dark: #00527c;
  --s-color-brand-dark-hsl-hue: 200;
  --s-color-brand-dark-hsl-saturation: 100%;
  --s-color-brand-dark-hsl-light: 24%;
  --s-color-brand-dark-red: 0;
  --s-color-brand-dark-green: 82;
  --s-color-brand-dark-blue: 124;

  --s-color-searchbox-background: #00527c;
  --s-color-searchbox-background-hsl-hue: 200;
  --s-color-searchbox-background-hsl-saturation: 100%;
  --s-color-searchbox-background-hsl-light: 24%;
  --s-color-searchbox-background-red: 0;
  --s-color-searchbox-background-green: 82;
  --s-color-searchbox-background-blue: 124;

  --s-color-searchbox-text: #393939;
  --s-color-searchbox-text-hsl-hue: 0;
  --s-color-searchbox-text-hsl-saturation: 0%;
  --s-color-searchbox-text-hsl-light: 22%;
  --s-color-searchbox-text-red: 57;
  --s-color-searchbox-text-green: 57;
  --s-color-searchbox-text-blue: 57;

  --s-color-footer-background: #00527c;
  --s-color-footer-background-hsl-hue: 200;
  --s-color-footer-background-hsl-saturation: 100%;
  --s-color-footer-background-hsl-light: 24%;
  --s-color-footer-background-red: 0;
  --s-color-footer-background-green: 82;
  --s-color-footer-background-blue: 124;

  --s-color-footer-text: #393939;
  --s-color-footer-text-hsl-hue: 0;
  --s-color-footer-text-hsl-saturation: 0%;
  --s-color-footer-text-hsl-light: 22%;
  --s-color-footer-text-red: 57;
  --s-color-footer-text-green: 57;
  --s-color-footer-text-blue: 57;
}

.currency-container {
  display: flex;
  align-items: center;
  border: 1px solid var(--border-color);
  /* border-radius: 8px;  */
  overflow: hidden;
  background-color: #ffffff;
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);  */
  transition: border-color 0.2s, box-shadow 0.2s; /* Transición suave en el borde y la sombra */
}

.currency-select {
  border: 1px solid #e3e3e3 !important;
  background-color: #f9fafb; /* Fondo ligeramente gris para distinguirlo */
  padding: 10px 14px;
  font-size: 1rem; /* Usar rem para mejor escalabilidad */
  color: var(--text-color);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  /* border-right: 1px solid var(--border-color); */
  transition: background-color 0.2s;
}

/* Estado de hover y focus para el select */
.currency-select:hover {
  background-color: #e5e7eb;
}

.currency-select:focus {
  outline: none;
  background-color: #e5e7eb;
}

.currency-input {
  flex-grow: 1;
  border: 1px solid #e3e3e3 !important;
  padding: 10px 0px 10px 10px;
  font-size: 1rem;
  color: var(--text-color);
  background-color: #ffffff;
  transition: background-color 0.2s;
}

.currency-input::placeholder {
  /* color: var(--placeholder-color); */
  color: #d1d1d1;
}

.currency-input:focus {
  outline: none;
  background-color: #f9fafb; /* Fondo ligero cuando está en foco */
}
</style>
